import React from 'react';

import { TEXTS } from 'application/pages/texts';
import { StreamType } from '@entities/stream';

import StreamPreviewSection from '../StreamPreviewSection';
import StreamPreviewCardSkeletons from '../StreamPreviewCardSkeletons';

interface StreamPreviewCardRendererProps {
  isLoading: boolean;
  withPoint: StreamType[];
  withoutPoint: StreamType[];
  streamIds: Map<string, boolean>;
  setStreamIds: React.Dispatch<React.SetStateAction<Map<string, boolean>>>;
  setIsAllSelected: React.Dispatch<React.SetStateAction<boolean>>;
}

export enum POINTS_TYPES_ENUM {
  WITH_POINT,
  WITHOUT_POINT,
}

const StreamPreviewCardRenderer = (props: StreamPreviewCardRendererProps) => {
  const { isLoading, withPoint, withoutPoint, streamIds, setStreamIds, setIsAllSelected } = props;

  const pointsData = [
    {
      id: 1,
      data: withPoint,
      text: TEXTS.CUSTOM_CONTENT_MODAL_STREAMS_SELECT_SECTION_FIRST,
      type: POINTS_TYPES_ENUM.WITH_POINT,
    },
    {
      id: 2,
      data: withoutPoint,
      text: TEXTS.CUSTOM_CONTENT_MODAL_STREAMS_SELECT_SECTION_SECOND,
      type: POINTS_TYPES_ENUM.WITHOUT_POINT,
    },
  ];

  if (isLoading) {
    return <StreamPreviewCardSkeletons />;
  }

  const renderStreamWithPoints = (point: (typeof pointsData)[0]) => {
    if (!pointsData.length) {
      return null;
    }

    return (
      <StreamPreviewSection
        key={point.id}
        text={point.text}
        pointData={point.data}
        streamIds={streamIds}
        setStreamIds={setStreamIds}
        setIsAllSelected={setIsAllSelected}
        type={point.type}
      />
    );
  };

  return pointsData.map(renderStreamWithPoints);
};

export default StreamPreviewCardRenderer;
